import { render, staticRenderFns } from "./orderBuyComp.vue?vue&type=template&id=22890cc0"
import script from "./orderBuyComp.vue?vue&type=script&lang=js"
export * from "./orderBuyComp.vue?vue&type=script&lang=js"
import style0 from "./orderBuyComp.vue?vue&type=style&index=0&id=22890cc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports